import React, {useCallback} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {CtaButton} from '@optimaxdev/design-system';

import {TYP_CTA} from 'constants/analytics/events/typ';

import s from '../successMessageWithoutDash.scss';

/**
 * Continue shopping button
 * @returns {React.ReactNode} react template
 */
export const ContinueShoppingButton = () => {
    const onClick = useCallback(() => {
        sendDesktopAnalyticsEvent(TYP_CTA, {
            label: 'Continue Shopping',
        });
    }, []);
    return (
        <CtaButton
            className={s.cta}
            href="/"
            isFull={false}
            onClick={onClick}
            renderAs="a"
            size="large"
        >
            Continue Shopping
        </CtaButton>
    );
};
